import React, { useState } from "react";
import useStyles from "./style";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Slide,
  Typography,
  Button,
  IconButton,
  TextField,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import { useFormik } from "formik";
import { useDropzone } from "react-dropzone";
import * as yup from "yup";

//Libs
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch, useSelector } from "react-redux";

//Services
import Bannerapi from "Services/Bannermanage";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Bannercreate = (props) => {
  const { openDialog, handleClose } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const demoaccount_id = useSelector(
    (state) => state?.AuthReducer?.demoaccount_id || ""
  );
  const [bannerImagePreview, setBannerImagePreview] = useState(null);

  // Max file size (5MB)
  const maxFileSize = 5242880;
  const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };

  const fileLengthValidator = (file) => {
    if (file.size > maxFileSize) {
      alert(`File size is larger than ${formatBytes(maxFileSize)}`);
      return {
        code: "file-too-large",
        message: `File size is larger than ${formatBytes(maxFileSize)}`,
      };
    }
    return null;
  };

  // Dropzone for BannerImage
  const {
    getRootProps: rootforBannerImage,
    getInputProps: inputforBannerImage,
    open: openforBannerImage,
  } = useDropzone({
    noClick: true,
    noKeyboard: true,
    maxSize: maxFileSize,
    maxFiles: 1,
    accept: { "image/*": [] },
    validator: fileLengthValidator,
    onDrop: (acceptedFiles) => {
      if (acceptedFiles && acceptedFiles.length > 0) {
        const file = acceptedFiles[0];
        const reader = new FileReader();
        reader.onload = () => {
          const base64String = reader.result;
          formik.setFieldValue("BannerImage", file);
          setBannerImagePreview(base64String);
        };
        reader.onerror = (error) => {
          console.error("Error converting file to Base64:", error);
        };
        reader.readAsDataURL(file);
      }
    },
  });

  const handleAddBanner = (formValues) => {
    dispatch(showLoader("Loading please wait..."));

    const data = {
      BannerName: formValues?.BannerName?.trim(),
      BannerImage: formValues?.BannerImage,
    };

    if (demoaccount_id) {
      data.demoaccount_id = demoaccount_id;
    }

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: res?.data?.message || "Banner Created Successfully",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );

        formik.resetForm();
        setBannerImagePreview(null);
        handleClose();
      }
    };

    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Error while creating Banner",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };

    Bannerapi.addBanner(data).then(onSuccess, onFailure);
  };

  const formik = useFormik({
    initialValues: {
      BannerImage: "",
      BannerName: "",
    },
    validationSchema: yup.object({
      BannerName: yup.string().required("Banner Name is required").nullable(),
      BannerImage: yup.mixed().required("Banner Image is required").nullable(),
    }),
    enableReinitialize: true,
    onSubmit: handleAddBanner,
  });

  const handleModalClose = () => {
    formik.resetForm();
    setBannerImagePreview(null);
    handleClose();
  };

  return (
    <Dialog
      open={openDialog}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleModalClose}
      fullWidth
      classes={{ paper: classes.dialogPaper }}
    >
      {/* Top Black Header */}
      <DialogTitle className={classes.headerBar}>
        <Typography className={classes.headerTitle}>Add Banner</Typography>
        <IconButton aria-label="close" onClick={handleModalClose} className={classes.closeIconBtn}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent className={classes.contentContainer}>
        {/* Banner image title */}
        <Typography className={classes.sectionTitle}>Banner image</Typography>

        {/* Upload Box */}
        <Box {...rootforBannerImage()} onClick={openforBannerImage} className={classes.uploadBox}>
          <input {...inputforBannerImage()} />
          {bannerImagePreview ? (
            <Box
              component="img"
              src={bannerImagePreview}
              alt="Banner preview"
              className={classes.previewImage}
            />
          ) : (
            <>
              <FileUploadOutlinedIcon className={classes.uploadIcon} />
              <Typography className={classes.uploadText}>
                Click to upload banner image
              </Typography>
            </>
          )}
        </Box>
        {formik.errors.BannerImage && formik.touched.BannerImage && (
          <Typography color="error" variant="caption" display="block" sx={{ mt: -1, mb: 2, textAlign: "center" }}>
            {formik.errors.BannerImage}
          </Typography>
        )}

        {/* Banner Name Field */}
        <Typography className={classes.fieldLabel}>Banner Name</Typography>
        <TextField
          name="BannerName"
          id="BannerName"
          placeholder="Enter the details"
          value={formik?.values?.BannerName}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={Boolean(formik?.errors?.BannerName && formik?.touched?.BannerName)}
          helperText={
            formik?.errors?.BannerName && formik?.touched?.BannerName
              ? formik?.errors?.BannerName
              : ""
          }
          fullWidth
          variant="outlined"
          multiline
          rows={3}
          className={classes.textField}
        />

        {/* Action Buttons */}
        <Box className={classes.buttonContainer}>
          <Button variant="outlined" onClick={handleModalClose} className={classes.cancelBtn}>
            Close
          </Button>
          <Button variant="contained" onClick={formik?.handleSubmit} className={classes.submitBtn}>
            Upload Banner
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default Bannercreate;
